import { l } from '../../lib/imports'
import { common } from '../../main/common-sidecar'
import { golfPhysicsTest } from './physics/golfPhysicsTest-sidecar'

const namespace = 'keys-golf'

let keys = {
  godMode: false,
  shift: false,
  control: false,
  alt: false,

  cameraUp: false,
  cameraDown: false,
  cameraLeft: false,
  cameraRight: false,
}

export const getKeys = () => {
  return keys
}

interface IKeyHandler {
  code: string
  on?: () => void
  off?: () => void
  change?: (isDown: boolean) => void
}
let _handlers: IKeyHandler[] = []

const addHandler = (
  codes: string | string[],
  on: () => void = () => {},
  off: () => void = () => {},
  change: (isDown: boolean) => void = () => {},
) => {
  if (!l.isArray(codes)) {
    codes = [codes]
  }
  l.forEach(codes, (c) => {
    _handlers.push({ code: c, on, off, change })
  })
}

const addKey = (codes: string | string[], property: keyof typeof keys) => {
  addHandler(
    codes,
    () => {},
    () => {},
    (isDown) => {
      // console.log('key property changed', codes, property, isDown)
      keys[property] = isDown
    },
  )
}

export const create = () => {
  let s = common.getPhaserScene()

  // l.forEach(textInputs.textInputAlphabet, (c) => {
  //   s.input.keyboard.addKey(c)
  // })

  addKey(['ShiftLeft', 'ShiftRight'], 'shift')
  addKey(['ControlLeft', 'ControlRight'], 'control')
  addKey(['AltLeft', 'AltRight'], 'alt')

  addKey(['KeyW', 'ArrowUp'], 'cameraUp')
  addKey(['KeyA', 'ArrowLeft'], 'cameraLeft')
  addKey(['KeyS', 'ArrowDown'], 'cameraDown')
  addKey(['KeyD', 'ArrowRight'], 'cameraRight')

  // s.input.keyboard.addKey('Space')
  // addHandler('Space', () => {
  //   voyageGameManager.togglePause()
  // })

  // s.input.keyboard.addKey('ESC')
  // addHandler('Escape', () => {
  //   voyagePicker.clearSelection()
  // })

  s.input.keyboard.addKey('END')
  // addHandler('End', () => {
  //   if (chessWebsockets.getIsHost()) {
  //     chessMessageHostCommand.sendMessageAndImmediatelyExecute({
  //       command: EChessHostCommand.Reset,
  //     })
  //   }
  // })

  // addHandler(['NumpadEnter', 'Enter'], () => {
  //   if (chessUiMessage.get().isOpen) {
  //     chessUiMessage.setOpen(false)
  //   }
  // })

  // addHandler(['Escape'], () => {
  //   if (chessUiMessage.get().isOpen) {
  //     chessUiMessage.setOpen(false)
  //   }
  //   if (chessUiPrompt.get().isOpen) {
  //     chessUiPrompt.setOpen(false)
  //   }
  // })

  // addHandler('KeyP', () => {
  //   chessSounds.toggleSounds()
  // })
  // addHandler('KeyM', () => {
  //   chessSounds.toggleMusic()
  // })

  addHandler('Space', () => {
    golfPhysicsTest.knock()
  })

  // addHandler('Numpad1', () => {
  //   chessTestParams.setTestMode('normal')
  // })
  // addHandler('Numpad2', () => {
  //   chessTestParams.setTestMode('game')
  // })
  // addHandler('Numpad3', () => {
  //   chessTestParams.setTestMode('game')
  // })

  // addHandler('Numpad4', () => {
  //   chessTestParams.setTestMode('ai')
  // })
  // addHandler('Numpad5', () => {
  //   chessTestParams.setTestMode('ai2')
  // })

  console.log(namespace, 'add keyboard handler')
  s.input.keyboard.on('keydown', (event: any) => {
    console.log(
      namespace,
      'key down',
      'key',
      event.key,
      'keyCode',
      event.keyCode,
      'code',
      event.code,
    )

    // if (underMenuController.handleKeydown(event.code)) {
    //   return
    // }

    //if (textInputs.hasFocus()) {
    //textInputs.handleKeyboardInput(event.key, event.keyCode, event.code)
    //} else {
    l.forEach(_handlers, (c) => {
      if (c.code === event.code) {
        console.log(namespace, 'hit handler')
        if (c.on) {
          c.on()
        }
        if (c.change) {
          c.change(true)
        }
      }
    })
    //}
  })

  s.input.keyboard.on('keyup', (event: any) => {
    // if (textInputs.hasFocus()) {
    //textInputs.handleKeyboardInput(event.key, event.keyCode, event.code)
    //} else {
    l.forEach(_handlers, (c) => {
      if (c.code === event.code) {
        if (c.off) {
          c.off()
        }
        if (c.change) {
          c.change(false)
        }
      }
    })
    //}
  })
}
